import { render, staticRenderFns } from "./EnquiryTable.vue?vue&type=template&id=129a54f4&"
import script from "./EnquiryTable.vue?vue&type=script&lang=js&"
export * from "./EnquiryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports